/** Returns locale-specific FAQ entries used by the FAQPage JSON-LD schema. */
export const getFaqSeoEntries = (t) =>
  t('faq.seoEntries', { returnObjects: true });
